<template>
    <multiplier
        :items="items"
        :min="min"
        :max="max"
        v-on:add-item="onAddItemEvent"
        v-on:remove-item="onRemoveItemEvent"
        :addBtnLabel="addBtnLabel"
    >
        <template v-slot:formrow="{ item, i }">
            <div class="formGroup formGroup--regular">
                <select
                    class="formInput | formSelect | col-4"
                    :class="{ 'has-error': hasError(i, 'category') }"
                    :id="`vantives[${i}][category]`"
                    :name="`vantives[${i}][category]`"
                    v-model="item.category"
                >
                    <option
                        value=""
                        disabled="disabled"
                        selected="selected"
                    >{{ categoryPlaceholder }}</option>

                    <option
                        v-for="(c, i) in parsedCategories"
                        :key="i"
                        :value="c.value"
                    >{{ c.label }}</option>
                </select>
            </div>
            <div class="formGroup formGroup--medium">
                <input
                    class="formInput"
                    :class="{ 'has-error': hasError(i, 'vantive_number') }"
                    type="text"
                    :id="`vantives[${i}][vantive_number]`"
                    :name="`vantives[${i}][vantive_number]`"
                    value=""
                    :placeholder="numberPlaceholder"
                    v-model="item.vantive_number"
                />
            </div>
        </template>
    </multiplier>
</template>



<script>

import Multiplier from './Multiplier.vue'

export default {

    /* Settings
    --------------------------------------------------------- */

    name: 'VantivesMultiplier',


    props: {
        categoryPlaceholder: { type: String, required: true },
        numberPlaceholder: { type: String, required: true },
        categories: { type: String, required: true },
        min: { type: Number, default: 1 },
        max: { type: Number, default: 10 },
        addBtnLabel: { type: String, default: 'Add a vantive' },
        vantives: { type: Array, default: () => [{ category: '', vantive_number: '' }] },
        errors: { type: Object, default: () => {} },
    },


    components: {
        Multiplier,
    },


    data() {
        return {
            items: this.vantives.length ? this.vantives : [{ category: '', vantive_number: '' }],
        }
    },




    /* Data Handling
    --------------------------------------------------------- */

    computed: {
        parsedCategories() {
            return JSON.parse(this.$props.categories)
        },
    },


    watch: {
        //
    },




    /* Methods
    --------------------------------------------------------- */

    methods: {
        onAddItemEvent() {
            this.$data.items.push({ cat: '', number: '' })
        },


        onRemoveItemEvent(e) {
            this.$data.items.splice(e.index, 1)
        },

        hasError(i, name) {
            return Object.prototype.hasOwnProperty.call(this.errors, `vantives.${i}.${name}`)
        },
    },

}

</script>
